import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { productConfig } from '@shared/config';
import { BrandLogo } from '@/components/brand/brand-logo';
import { LanguageToggle } from '@/components/navigation/language-toggle';
import { routes } from '@/lib/routes';

export function PublicFooter() {
  const { t } = useTranslation('common');
  return (
    <footer className="public-footer">
      <div className="container public-footer__grid">
        <div className="public-footer__brand">
          <BrandLogo />
          <p>{t('footer.tagline')}</p>
          <LanguageToggle />
        </div>
        <div className="footer-links">
          <h2>{t('footer.product')}</h2>
          <Link to={routes.cvFeature}>{t('nav.cvBuilder')}</Link>
          <Link to={routes.linkedinFeature}>{t('nav.linkedin')}</Link>
          <Link to={routes.interviewFeature}>{t('nav.interview')}</Link>
          <Link to={routes.pricing}>{t('footer.pricing')}</Link>
        </div>
        <div className="footer-links">
          <h2>{t('footer.company')}</h2>
          <Link to={routes.privacy}>{t('footer.privacy')}</Link>
          <Link to={routes.terms}>{t('footer.terms')}</Link>
          <Link to={`${routes.privacy}#contact`}>{t('footer.contact')}</Link>
        </div>
      </div>
      <div className="container public-footer__bottom">
        <p>
          © {new Date().getFullYear()} {productConfig.brandName}. {t('footer.rights')}
        </p>
        <p>{t('footer.draftNotice')}</p>
      </div>
    </footer>
  );
}
